import React from 'react';
import './noResults.css';

export const NoResults = ({ icon, title, summary }) => {
    return (
        <div className="no-results-holder flex flex-center flex-column pt10 pb10">
            <i className={`fa fa-${icon}`} style={{ fontSize: '48px' }} />
            <h4 className="mt20 mb10">{title}</h4>
            <span>{summary}</span>
        </div>
    );
};

export default NoResults;
